import { createContext, useContext, useEffect, useState, useCallback } from "react";

export const CURRENCIES = [
  { code: "USD", symbol: "$" }, { code: "CAD", symbol: "CA$" }, { code: "GBP", symbol: "£" },
  { code: "EUR", symbol: "€" }, { code: "INR", symbol: "₹" }, { code: "AUD", symbol: "A$" },
];

const Ctx = createContext({ currency: "USD", setCurrency: () => {}, format: (v) => `$${v}` });

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState(() => localStorage.getItem("rcf_currency") || "USD");
  const [rates, setRates] = useState({ USD: 1 });

  useEffect(() => {
    fetch("https://open.er-api.com/v6/latest/USD")
      .then((r) => r.json())
      .then((d) => { if (d?.rates) setRates(d.rates); })
      .catch(() => {});
  }, []);

  useEffect(() => { localStorage.setItem("rcf_currency", currency); }, [currency]);

  const format = useCallback((usd) => {
    const rate = rates?.[currency];
    const cur = CURRENCIES.find((c) => c.code === currency);
    if (!rate || !cur) return `$${usd}`;
    return `${cur.symbol}${Math.round(usd * rate).toLocaleString()}`;
  }, [currency, rates]);

  return <Ctx.Provider value={{ currency, setCurrency, format }}>{children}</Ctx.Provider>;
};

export const useCurrency = () => useContext(Ctx);
